// extracted by mini-css-extract-plugin
export default {"actionContainer":"styles_actionContainer__I8EVs","actionDots":"styles_actionDots__wRe9y","actionMenuItem":"styles_actionMenuItem__fvJvp","dot":"styles_dot__I21lN"};